module.exports = __webpack_public_path__ + "static/img/17.470fac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/17.jpg
// module id = 1fXi
// module chunks = 1